import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';

export default function UnlockButton() {
  const [loading, setLoading] = useState(false);
  const { t } = useLanguage();

  const API_BASE = (process.env.REACT_APP_API_BASE_URL || "http://localhost:3001").replace(/\/$/, "");
  const handleUnlock = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_BASE}/create-checkout-session`, {
        method: 'POST',
      });
      const data = await res.json();
      if (data.url) {
        window.location.href = data.url;
      } else {
        alert('Payment failed, please try again.');
      }
    } catch (err) {
      console.error('Error:', err);
      alert('Error connecting to payment system.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleUnlock}
      disabled={loading}
      className="primary-button unlock-button"
      aria-disabled={loading}
    >
      {loading ? t('processing') : (
        <>
          {t('unlockStripe')}
          <span className="unlock-price">$1</span>
        </>
      )}
    </button>
  );
}
